<template>
  <v-card class="my-0">
    <v-card-title class="display-1">
      {{ title }}
    </v-card-title>
    <v-card-text>
      <highcharts :options="chartOptions" />
    </v-card-text>
  </v-card>
</template>

<script>
  import Highcharts from "highcharts";
  import HighchartsNoData from "highcharts/modules/no-data-to-display";
  HighchartsNoData(Highcharts);

  export default {
    name: "IndicadorBySupGerChart",
    props: {
      isSup: {
        type: Boolean,
        default: false
      },
      indicador: {
        type: Object,
        required: true,
      },
      listSupGer: {
        type: Array,
        required: true,
      },
      dados: {
        type: Object,
        required: true,
      },
    },
    computed: {
      title() {
        const tipo = this.isSup ? "Área" : "Gerência";

        return `${this.indicador.text} x PSP por ${tipo}`;
      },
      sortedData() {
        return this.listSupGer
          .map((sup) => {
            const indicador = parseFloat(
              this.dados[sup]?.[this.indicador.value] ?? 0
            );
            const psp = parseFloat(this.dados[sup]?.psp ?? 0);

            return {
              sup,
              indicador,
              psp,
            };
          })
          .sort((a, b) => (a.indicador < b.indicador ? 1 : -1));
      },
      categories() {
        return this.sortedData.map(el => el.sup);
      },
      indicadorData() {
        return this.sortedData.map((el) => [el.sup, el.indicador]);
      },
      pspData() {
        return this.sortedData.map((el) => [el.sup, el.psp]);
      },
      shouldUseLogarithmic() {
        return ["qtd_servicos", "valor_creditado"].includes(
          this.indicador.value
        );
      },
      chartOptions() {
        return {
          chart: {
            zoomType: "x",
          },
          title: { text: null },
          credits: { enabled: false },
          xAxis: [
            {
              categories: this.categories,
              type: "category",
              crosshair: true,
            },
          ],
          yAxis: [
            {
              type: this.shouldUseLogarithmic ? "logarithmic" : "linear",
              title: { text: this.indicador.text },
              opposite: false,
            },
            {
              title: { text: "PSP (%)" },
              opposite: true,
              max: 100,
            },
          ],
          tooltip: { shared: true },
          series: [
            {
              name: this.indicador.text,
              type: "column",
              data: this.indicadorData,
              yAxis: 0,
            },
            {
              name: "PSP (%)",
              type: "spline",
              data: this.pspData,
              yAxis: 1,
              tooltip: { valueSuffix: " %" },
            },
          ],
        };
      },
    },
    methods: {
      //
    },
  };
</script>
